import { UPDATE_SEARCHDATA_CUAHANG } from "actions/DanhSachCuaHang/actionTypes";

const initialState = {
  nameSearch: "",
  statusSearch: "10",
};
const updateDataSearch = (state, action) => ({
  ...action.payload,
});
export const dataSearchCuaHang = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHDATA_CUAHANG:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchCuaHang;
